
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuEkichikaHarajukuStationNearImage } from "@src/constants/images";
import { meta as ryunokoPageMeta } from "./ryunoko.mdx";
import { meta as noodleStandTokyoPageMeta } from "./noodle_stand_tokyo.mdx";
import { meta as minoringoPageMeta } from "./minoringo.mdx";
import { meta as afuriPageMeta } from "./afuri.mdx";
export const meta = {
  path: "/media/harajuku/ekichika",
  title: "【駅徒歩5分以内】原宿ランチの名店5選をご紹介！",
  description: "原宿駅から徒歩5分以内のアクセスにある原宿近辺で名店のランチができる店をご紹介します！雨の日、暑い日、寒い日などはなるべく近場のところでランチを食べたいですし、あまり駅から遠いところでランチをするのは嫌だという方にはおすすめの記事になっています。今回は5分以内の原宿近辺の中でも、百名店や食べログも3.5を超える名店を厳選してご紹介させていただきます。",
  topImg: harajukuEkichikaHarajukuStationNearImage,
  author: murakamiMasanori,
  tags: ["原宿", "有名店", "人気店", "まとめ記事", "駅近"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿駅から徒歩 5 分以内のアクセスにある原宿近辺で名店のランチができる店をご紹介します！`}</p>
    <p>{`雨の日、暑い日、寒い日などはなるべく近場のところでランチを食べたいですし、あまり駅から遠いところでランチをするのは嫌だという方にはおすすめの記事になっています。`}</p>
    <p>{`ジャンル別にお店を分け、駅徒歩の時間とおすすめのメニューもご紹介。`}</p>
    <p>{`原宿近辺の中でも、百名店や食べログも 3.5 を超える名店を厳選してご紹介させていただきますので、ランチの味が保証できるお店になっています。`}</p>
    <h2>{`【ラーメン】The Noodle Stand Tokyo`}</h2>
    <InstaImage postId="BwUVy_ZBKa1" mdxType="InstaImage" />
    <p>{`独創的なメニューを提供するお店として有名で、TBS 主催の鬼旨ラーメン GP をはじめとして、たくさんのテレビやメディアに取り上げられているのが The Noodle Stand Tokyo。
原宿近辺という土地柄や斬新なメニューが人気を呼び、外国人のお客様も多く、ランチには行列ができることもあるそうです。
斬新なメニューに加えて、食べログの評価も高く、味もしっかりしているのが特徴。`}</p>
    <h3>{`原宿駅から徒歩 1 分`}</h3>
    <p>{`原宿駅の竹下口を出て信号を渡り、左にまっすぐ進むと The Noodle Stand Tokyo が発見できます。
地下に入り口があってわかりづらいかもしれませんが、この後紹介するカレーの名店みのりんごのすぐ手前の位置にあるので、見つけるのは意外と難しくないのではないかと思います。`}</p>
    <h3>{`ココナッツ味噌ラーメン`}</h3>
    <InstaImage postId="B9eHo1BHYzc" mdxType="InstaImage" />
    <p>{`独創的なメニューのひとつがラーメンにココナッツを使って作るココナッツ味噌ラーメン。ヴィーガン向けのココナッツ味噌ラーメンもメニューとして存在し、外国人や女性の方でヘルシーな料理が好みの方には、ランチでも胃もたれしないラーメンとして人気だそうです。`}</p>
    <h3>{`牛煮込みまぜそば`}</h3>
    <InstaImage postId="B6-uVdAAbxj" mdxType="InstaImage" />
    <p>{`有名 youtuber とのコラボ企画や、テレビでも紹介されているのがこちらのメニュー。牛煮込みのしっかりとした味付けと、コシのある麺が合わさる 1 番人気のメニューになります。`}</p>
    <LinkWithThumbnail meta={noodleStandTokyoPageMeta} mdxType="LinkWithThumbnail" />
    <hr></hr>
    <h2>{`【カレー】みのりんご`}</h2>
    <InstaImage postId="B_msNzYAyA9" mdxType="InstaImage" />
    <p>{`原宿のカレーでは絶対外せないキーマカレーが有名なお店がみのりんご 。
原宿駅近辺に位置する駅近の店で、そのアクセスの良さからランチでは大行列ができることもあります。
食べログの評価は 3.7 を超え、百名店にも選出されています！`}</p>
    <h3>{`原宿駅から徒歩 2 分`}</h3>
    <p>{`原宿駅の竹下口を出て信号を渡り、左にまっすぐ進むと写真の通り大きな黄色の旗と看板が見えてきます。`}</p>
    <p>{`一本道で看板もわかりやすいので、原宿駅から迷わず行くことができます。`}</p>
    <h3>{`とろーりチーズの無水キーマカレー`}</h3>
    <InstaImage postId="BEc6xI5jffp" mdxType="InstaImage" />
    <p>{`みのりんごの人気の理由の一つがこのとろーりチーズのキーマカレー。`}</p>
    <p>{`インスタ映えするこのメニューは原宿近辺だと見かけることはなく、ランチで多くの人が注文し、インスタグラムにもたくさんの社員が乗っています。`}</p>
    <p>{`キーマカレーは水を使用せず、肉や野菜から出る最低限の油と水しか使っていないので、見た目よりもヘルシーな味わいになっていることが、ランチ激戦区原宿でも人気の秘密になっています。`}</p>
    <h3>{`みのりんご スペシャル`}</h3>
    <InstaImage postId="B_jXFjEl-fR" mdxType="InstaImage" />
    <p>{`みのりんごにはたくさんのカレーの種類があり、みのりんご スペシャルは無水チキンカレーと無水キーマカレーが食べられるお得なランチメニュー。`}</p>
    <p>{`温泉玉子もトッピングされていて、いろんな味を楽しむことができるのが特徴となっています。`}</p>
    <p>{`一度に二つの味を楽しめるカレー店は、原宿近辺だけでなく日本でも珍しい一品なので、みのりんご にお越しの際は検討ください。`}</p>
    <LinkWithThumbnail meta={minoringoPageMeta} mdxType="LinkWithThumbnail" />
    <ShopInfoBox shopId="br5tsra23akg00ac688g" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【ラーメン】AFURI`}</h2>
    <InstaImage postId="B677lIVnwD6" mdxType="InstaImage" />
    <p>{`ミシュランに掲載されたことがあるお店として有名で、多くの外国人をはじめとした観光客の方が訪れるのが原宿近辺で有名なラーメン店 AFURI。阿夫利山の水を使用して作る出汁や、素材の味にも拘って作られるラーメンを求めて、連日行列を作ることもしばしば。`}</p>
    <h3>{`原宿駅から徒歩 2 分`}</h3>
    <p>{`原宿の竹下口を左に直進し、みのりんごを超えるとすぐに AFURI が発見できます。原宿近辺にある名店の中でも、アクセスが抜群のエリアに位置しており、それがランチで人気の一つにもなっていると思います。`}</p>
    <h3>{`柚塩らぁめん`}</h3>
    <InstaImage postId="CBaX-ZJA50u" mdxType="InstaImage" />
    <p>{`全国のコンビニエンスストアで見かけたり、食べたりしたことがある方も多いと思いますが、本来の AFURI の柚塩らぁめんはこちらになります。
透き通る黄金色のスープに、大きなチャーシューや卵などがトッピングされた柚塩らぁめん。柚のさっぱりとした味わいと香りが口の中に広がり、コシのある麺にも味が染み込んでいる食べ応えのある一品。`}</p>
    <p>{`原宿でさっぱりとしたラーメンをランチで駅近で食べたい方には、AFURI がおすすめです！`}</p>
    <LinkWithThumbnail meta={afuriPageMeta} mdxType="LinkWithThumbnail" />
    <ShopInfoBox shopId="brhpjf223akg00cq84ng" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【中華】龍の子`}</h2>
    <InstaImage postId="CAWfSrcgcAX" mdxType="InstaImage" />
    <p>{`原宿では珍しく創業 40 年以上の老舗で、現地の香辛料を使った本格四川料理が食べられるお店として、原宿・表参道・青山エリアで人気のお店。
食べログの評価も高く、原宿近辺には中華料理店も少ないため、ランチではたくさんの行列を作ることもしばしば。テイクアウトもコロナの影響で一時的に始めているので、テイクアウトで食べたい方にも嬉しいお店です。`}</p>
    <h3>{`原宿駅から徒歩 5 分`}</h3>
    <p>{`原宿の竹下口の改札を出て、原宿の竹下通りを抜けたところをすぐに右に曲がったビルの地下一階に龍の子はあります。`}</p>
    <p>{`地下に店舗があるものの、アクセスが非常に単純でわかりやすいので、迷わずにたどり着けるのではないかと思います。`}</p>
    <p>{`原宿近辺で中華がランチで食べたい時には、アクセス抜群の店舗なのでおすすめです。`}</p>
    <h3>{`麻婆豆腐`}</h3>
    <InstaImage postId="BGHBE_KQuFZ" mdxType="InstaImage" />
    <p>{`ランチで 1 番人気のメニューが麻婆豆腐ランチ。シビレと辛さの両方を調整できるようになっているので、初めての方や苦手な方も安心して注文できるのがポイント。`}</p>
    <h3>{`四川白ごま坦々麺`}</h3>
    <InstaImage postId="B-Ed8kSlpFH" mdxType="InstaImage" />
    <p>{`本格四川風の坦々麺が人気メニュー。見た目よりもボリューム感があり、食べきれない方もいるそうです。値段もリーズナブルなので、麻婆豆腐と比較してお好きな料理を楽しんでいただければと思います。`}</p>
    <LinkWithThumbnail meta={ryunokoPageMeta} mdxType="LinkWithThumbnail" />
    <ShopInfoBox shopId="brf4bdi23akg00d4ds20" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【ピザ】pizzeria CANTERA`}</h2>
    <InstaImage postId="B8_Dr1PAynw" mdxType="InstaImage" />
    <p>{`pizzeria CANTERA は見晴らしの良いおしゃれな空間が特徴的な店舗で、原宿や表参道近辺でのランチやディナーで使い勝手が良いお店として人気です。雰囲気はよく、料理はボリューミーで味付けも文句なしのお店。
そんな人気が、三年連続食べログ百名店に選出されている理由なのだと思います。`}</p>
    <h3>{`原宿駅から徒歩 5 分`}</h3>
    <p>{`キュープラザの 9 階に位置し、原宿駅の明治神宮前の改札を抜けて ZARA などがある大通りを真っ直ぐに進み、交差点を右に曲がると到着します。`}</p>
    <p>{`アクセスは簡単で、信号につかまることもないので、徒歩 5 分でのアクセスができるようになっています。`}</p>
    <h3>{`パスタかピザランチ`}</h3>
    <InstaImage postId="B-TR48pn1fm" mdxType="InstaImage" />
    <InstaImage postId="BxXklEQA7uH" mdxType="InstaImage" />
    <p>{`お得なランチセットを食べたいなら、パスタかピザのランチがおすすめです！二人以上でお越しの際には、別々のものを頼んでシェアをすると良いと思います。
原宿近辺でお得に、そしておしゃれにランチが食べたい方は、pizzeria CANTERA にお越しください。`}</p>
    <ShopInfoBox shopId="brjat6223akg00cd2nu0" mdxType="ShopInfoBox" />
    <hr></hr>
    <h3>{`おわりに　`}</h3>
    <p>{`原宿近辺で名店のランチが食べられるお店を厳選してご紹介してきました。行ってみたいお店は見つかりましたでしょうか？時間がない時や、アクセスが良いところでランチを食べたい方にとっては、おすすめの記事になっていますので、ぜひランチを楽しんでいただければと思います。`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;